import { useCallback, useMemo } from "react";
import { useMenuStore } from "../stores";
import useAuth from "./auth";
import { useSearchParams } from "./searchParams";

const useMenu = () => {
  const categories = useMenuStore((state) => state.categories);
  const cartSuggestions = useMenuStore((state) => state.cartSuggestions);
  const { user } = useAuth();
  const { searchParams, setSearchParams } = useSearchParams({ product: "" });
  const saved = user?.favorites;

  const items = useMemo(
    () =>
      (categories ?? []).flatMap((category) =>
        category.isPopular ? [] : category.items,
      ),
    [categories],
  );

  const favorites = useMemo(
    () => items.filter((item) => saved?.includes(item.uuid)),
    [items, saved],
  );

  const search = useCallback(
    (query: string) =>
      items.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase()),
      ),
    [items],
  );

  const openItem = (uuid: string) => {
    if (searchParams.product === uuid) return;
    setSearchParams({ product: uuid });
  };

  return { items, favorites, cartSuggestions, search, openItem };
};

export default useMenu;
